// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import BadgeData from "entity/BadgeData";
import BadgeDataUpload from "entity/BadgeDataUpload";
import BadgeQuestion from "entity/BadgeQuestion";
import Paging from "./Paging";
import SessionAttendee, { processSessionAttendeeArray } from "entity/SessionAttendee";
import StandardQuestion from "entity/StandardQuestion";

import { QueryParams, RestController, RestRequest } from "./RestController";

export default class BadgingController extends RestController {

    /*
     Create a badge question for a Scootaverse
     */

    apiKeyCreateBadgeQuestion(socialRoomSetId: string, question: BadgeQuestion): Promise<BadgeQuestion> {
        const request = new RestRequest("/api/v1/badging/api/key/badge/question", "POST", question, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion>;
    }

    /*
     Delete a badge question from a Scootaverse
     */

    apiKeyDeleteBadgeQuestion(socialRoomSetId: string, title: string): Promise<void> {
        const request = new RestRequest("/api/v1/badging/api/key/badge/question", "DELETE", null, { socialRoomSetId: socialRoomSetId, title: title });
        return this.requestVoid(request);
    }

    /*
     Get my badge data
     */

    apiKeyGetBadgeData(socialRoomSetId: string, userId: string, page?: Paging): Promise<BadgeData[]> {
        const request = new RestRequest("/api/v1/badging/api/key/user/badge/data", "GET", null, { socialRoomSetId: socialRoomSetId, userId: userId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<BadgeData[]>;
    }

    /*
     Save badge questions for a Scootaverse
     */

    apiKeySaveBadgeQuestions(socialRoomSetId: string, questions: BadgeQuestion[]): Promise<BadgeQuestion[]> {
        const request = new RestRequest("/api/v1/badging/api/key/badge/questions/save", "POST", questions, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion[]>;
    }

    /*
     Update a badge question for a Scootaverse
     */

    apiKeyUpdateBadgeQuestion(socialRoomSetId: string, question: BadgeQuestion): Promise<BadgeQuestion> {
        const request = new RestRequest("/api/v1/badging/api/key/badge/question/update", "POST", question, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion>;
    }

    apiKeyUploadBadgeData(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<BadgeDataUpload> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        const request = new RestRequest("/api/v1/badging/api/key/upload/badge/data", "POST", valuesCSV, queryParams);
        return this.request(request, null) as Promise<BadgeDataUpload>;
    }

    apiKeyUploadQuestions(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<void> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        const request = new RestRequest("/api/v1/badging/api/key/upload/question", "POST", valuesCSV, queryParams);
        return this.requestVoid(request);
    }

    /*
     Create a badge question for a Scootaverse
     */

    createBadgeQuestion(socialRoomSetId: string, question: BadgeQuestion): Promise<BadgeQuestion> {
        const request = new RestRequest("/api/v1/badging/badge/question", "POST", question, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion>;
    }

    /*
     Delete a badge question from a Scootaverse
     */

    deleteBadgeQuestion(socialRoomSetId: string, title: string): Promise<void> {
        const request = new RestRequest("/api/v1/badging/badge/question", "DELETE", null, { socialRoomSetId: socialRoomSetId, title: title });
        return this.requestVoid(request);
    }

    /*
     Get a badge question for a Scootaverse
     */

    getBadgeQuestion(socialRoomSetId: string, title: string): Promise<BadgeQuestion> {
        const request = new RestRequest("/api/v1/badging/badge/question", "GET", null, { socialRoomSetId: socialRoomSetId, title: title });
        return this.request(request, null) as Promise<BadgeQuestion>;
    }

    /*
     Get badge questions for a Scootaverse
     */

    getBadgeQuestions(socialRoomSetId: string, page?: Paging): Promise<BadgeQuestion[]> {
        const request = new RestRequest("/api/v1/badging/badge/questions", "GET", null, { socialRoomSetId: socialRoomSetId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<BadgeQuestion[]>;
    }

    /*
     Get guest badge data
     */

    getGuestBadgeData(socialRoomSetId: string, email: string): Promise<BadgeData[]> {
        const request = new RestRequest("/api/v1/badging/guest/badge/data", "GET", null, { socialRoomSetId: socialRoomSetId, email: email });
        return this.request(request, null) as Promise<BadgeData[]>;
    }

    /*
     Get my badge data
     */

    getMyBadgeData(socialRoomSetId: string, page?: Paging): Promise<BadgeData[]> {
        const request = new RestRequest("/api/v1/badging/user/badge/data", "GET", null, { socialRoomSetId: socialRoomSetId });
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<BadgeData[]>;
    }

    /*
     Get attendees and badge data for a Scootaverse session
     */

    getSessionAttendees(socialRoomSetId: string, sessionId: number, page?: Paging): Promise<SessionAttendee[]> {
        const request = new RestRequest("/api/v1/badging/session/attendee", "GET", null, { socialRoomSetId: socialRoomSetId, sessionId: sessionId });
        if (page) request.addPaging("", page);

        return this.request(request, processSessionAttendeeArray) as Promise<SessionAttendee[]>;
    }

    /*
     Get badge questions for a Scootaverse
     */

    getStandardQuestions(page?: Paging): Promise<StandardQuestion[]> {
        const request = new RestRequest("/api/v1/badging/standard/questions", "GET", null, undefined);
        if (page) request.addPaging("", page);

        return this.request(request, null) as Promise<StandardQuestion[]>;
    }

    /*
     Save badge questions for a Scootaverse
     */

    saveBadgeQuestions(socialRoomSetId: string, questions: BadgeQuestion[]): Promise<BadgeQuestion[]> {
        const request = new RestRequest("/api/v1/badging/badge/questions/save", "POST", questions, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion[]>;
    }

    /*
     Update badge data
     */

    updateBadgeData(socialRoomSetId: string, badgeData: BadgeData[]): Promise<BadgeData[]> {
        const request = new RestRequest("/api/v1/badging/badge/update", "POST", badgeData, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeData[]>;
    }

    /*
     Update a badge question for a Scootaverse
     */

    updateBadgeQuestion(socialRoomSetId: string, question: BadgeQuestion): Promise<BadgeQuestion> {
        const request = new RestRequest("/api/v1/badging/badge/question/update", "POST", question, { socialRoomSetId: socialRoomSetId });
        return this.request(request, null) as Promise<BadgeQuestion>;
    }

    uploadBadgeData(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<BadgeDataUpload> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        const request = new RestRequest("/api/v1/badging/upload/badge/data", "POST", valuesCSV, queryParams);
        return this.request(request, null) as Promise<BadgeDataUpload>;
    }

    uploadQuestions(socialRoomSetId: string, valuesCSV: string, removeOld?: boolean): Promise<void> {
        const queryParams: QueryParams = { socialRoomSetId: socialRoomSetId };
        if (removeOld !== undefined) {
          queryParams.removeOld = removeOld;
        }
        const request = new RestRequest("/api/v1/badging/upload/question", "POST", valuesCSV, queryParams);
        return this.requestVoid(request);
    }

}
